const HelpCenter = () => import("@/modules/Help/view/HelpCenter.vue")

export default [{
  path: "help",
  name: "help-center",
  component: HelpCenter,
}]

